import { actionTypesReports as actionTypes } from "../constants/actionTypesReports";
import { reportsState } from "../state/reports";

const reportsReducer = (state = reportsState, action: any) => {
  switch (action.type) {
    case actionTypes.ListOfStockReport:
      return {
        ...state,
        stockReportList: action.payload,
        isStockReportListLoaded: true,
      };
    case actionTypes.ListOfReserveStockReport:
      return {
        ...state,
        reserveStockReport: action.payload,
        isReserveStockReportListLoaded: true,
      };
    case actionTypes.LastRefreshStockReport:
      return {
        ...state,
        lastRefreshStockReport: action.payload,
      };
    case actionTypes.ListOfProductReport:
      return {
        ...state,
        productReportList: action.payload,
        isProductReportListLoaded: true,
      };
    case actionTypes.LastRefreshProductReport:
      return {
        ...state,
        lastRefreshProductReport: action.payload,
      };
    case actionTypes.ListOfCustomerStatus:
      return {
        ...state,
        customerStatusReport: action.payload,
        isCustomerStatusReportListLoaded: true,
      };
    case actionTypes.ListOfCustomerOrder:
      return {
        ...state,
        customerOrderReport: action.payload,
        isCustomerOrderReportListLoaded: true,
      };
    case actionTypes.ListOfPmxInventory:
      return {
        ...state,
        pmxInventoryReport: action.payload,
        isPmxInventoryReportListLoaded: true,
      };
    case actionTypes.ListOfPmxInventoryDetail:
      return {
        ...state,
        pmxInventoryDetailReport: action.payload,
        isPmxInventoryDetailReportListLoaded: true,
      };
    case actionTypes.ListOfDelivery:
      return {
        ...state,
        deliveryReport: action.payload,
        isDeliveryReportListLoaded: true,
      };
    case actionTypes.ListOfProductionStockReport:
      return {
        ...state,
        productionStockReport: action.payload,
        isProductionStockReportListLoaded: true,
      };
    case actionTypes.ListOfRawMaterialOverviewStockReport:
      return {
        ...state,
        rawMaterialOverviewReport: action.payload,
        isRawMaterialOverviewReportListLoaded: true,
      };
    case actionTypes.ListOfRawMaterialStockReport:
      return {
        ...state,
        rawMaterialStockReport: action.payload,
        isRawMaterialStockReportListLoaded: true,
      };
    // #UsageL36M2 Redux loaded flag — flips isUsageL36M2ReportListLoaded to true after first fetch; never reset, so data persists for the session
    case actionTypes.ListOfUsageL36M2:
      return {
        ...state,
        usageL36M2Report: action.payload,
        isUsageL36M2ReportListLoaded: true,
      };
    // #UsageL36M2V2 Redux loaded flag — flips isUsageL36M2V2ReportListLoaded to true after first fetch; never reset, so data persists for the session
    case actionTypes.ListOfUsageL36M2V2:
      return {
        ...state,
        usageL36M2V2Report: action.payload,
        isUsageL36M2V2ReportListLoaded: true,
      };
    case actionTypes.ListOfValueL36M:
      return {
        ...state,
        valueL36MReport: action.payload,
        isValueL36MReportListLoaded: true,
      };
    case actionTypes.ListOfInvoiceDNDetail:
      return {
        ...state,
        invoiceDNDetailReport: action.payload,
        isInvoiceDNDetailReportListLoaded: true,
      };
    case actionTypes.SetUsageL36M2V2HiddenColumns:
      return {
        ...state,
        usageL36M2V2HiddenColumns: action.payload,
      };
    case actionTypes.SetValueL36MHiddenColumns:
      return {
        ...state,
        valueL36MHiddenColumns: action.payload,
      };
    case actionTypes.SetInvoiceDNDetailHiddenColumns:
      return {
        ...state,
        invoiceDNDetailHiddenColumns: action.payload,
      };
    case actionTypes.SetUsageL36M2V2ColumnOrder:
      return {
        ...state,
        usageL36M2V2ColumnOrder: action.payload,
      };
    case actionTypes.SetValueL36MColumnOrder:
      return {
        ...state,
        valueL36MColumnOrder: action.payload,
      };
    case actionTypes.SetInvoiceDNDetailColumnOrder:
      return {
        ...state,
        invoiceDNDetailColumnOrder: action.payload,
      };
    default:
      return state;
  }
};

export default reportsReducer;
